import { FC } from 'react';
import { Button, ButtonStyles, Checkbox, Icons, Radio, TextInput, TextInputSizes } from '@silverfort/sf-components';

const EmailSectionLoader: FC = () => (
    <div className="rounded-[8px] border border-sf-gray-100">
        <div className="px-4 h-14 flex items-center border-b border-sf-gray-100">
            <span className="font-sf font-medium text-13 leading-[15.87px]">Email</span>
        </div>
        <div className="p-4 flex flex-col gap-2">
            <div className="flex items-center gap-2">
                <div className="flex flex-row items-center gap-2 text-[13px] font-normal">
                    <Radio
                        disabled
                        checked={false}
                        value={1}
                        title="AD default"
                        onChange={() => {}}
                        containerClassName=""
                    />
                    <Radio disabled checked={false} value={2} title="Email" onChange={() => {}} containerClassName="" />
                </div>
                <div className="flex flex-col gap-1 max-h-8">
                    <TextInput
                        disabled
                        inputSize={TextInputSizes.Small}
                        value=""
                        placeholder="Email address"
                        onChange={() => {}}
                    />
                </div>
            </div>
            <div className="flex items-center justify-between">
                <Checkbox disabled label="Mark as external email" checked={false} onChange={() => {}} />
                <Button disabled text="Send" buttonStyle={ButtonStyles.Primary} iconLeft={Icons.Mail} />
            </div>
        </div>
    </div>
);

export default EmailSectionLoader;
